import Lottie, { type LottieRef } from "lottie-react";
import { useEffect, useRef } from "react";
import type { LottieAnimationProps } from "./types";

/**
 * CSS rules that override the inline SVG fill/stroke values emitted by
 * lottie-web with `currentColor`, which inherits the wrapper's `color`
 * property.
 */
const COLOR_OVERRIDE_STYLES = `
.medbillai-lottie svg [stroke]:not([stroke="none"]):not([stroke="transparent"]) {
  stroke: currentColor !important;
}
.medbillai-lottie svg [fill]:not([fill="none"]):not([fill="transparent"]) {
  fill: currentColor !important;
}`;

/**
 * Web Lottie animation renderer.
 *
 * Uses `lottie-react` (lottie-web SVG renderer). Uses CSS currentColor to tint the animation.
 */
export const LottieAnimation = ({
  source,
  width,
  height,
  playing,
  loop = true,
  color
}: LottieAnimationProps) => {
  const lottieRef: LottieRef = useRef(null);
  useEffect(() => {
    if (playing === undefined) {
      return;
    }
    if (playing) {
      lottieRef.current?.play();
    } else {
      lottieRef.current?.pause();
    }
  }, [playing]);
  return <div className="medbillai-lottie" style={{
    width,
    height,
    ...(color ? {
      color
    } : undefined),
    lineHeight: 0
  }} data-sentry-component="LottieAnimation" data-sentry-source-file="LottieAnimation.tsx">
      {color ? <style>{COLOR_OVERRIDE_STYLES}</style> : null}
      <Lottie lottieRef={lottieRef} animationData={source} autoplay={playing === undefined} loop={loop} style={{
      width,
      height
    }} data-sentry-element="Lottie" data-sentry-source-file="LottieAnimation.tsx" />
    </div>;
};